import MacAddress from '../../../base/errors/airdome/MacAddress';

const macAddress: MacAddress = {
  unableToAdd: 'Nepodařilo se přidat MAC adresu zařízení',
  unableToRemove: 'Nepodařilo se odebrat MAC adresu zařízení'
};

export default macAddress;
